import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { MainSliderSection } from "../pages/dashboard/dashboard.page";

@Injectable({
  providedIn: 'root'
})
export class StateService {

  private changeMainSliderSectionObservable: BehaviorSubject<any>;
  private mainSliderSectionSettledObservable: Subject<MainSliderSection>;

  constructor() {
    this.changeMainSliderSectionObservable = new BehaviorSubject(null);
    this.mainSliderSectionSettledObservable = new Subject();
  }

  getMainSliderSectionObservable(){
    return this.changeMainSliderSectionObservable;
  }

  getMainSliderSectionSettledObservable(){
    return this.mainSliderSectionSettledObservable;
  }

  //If code calling this function is nested in a promise, set includeTimeout to true which
  //will solve a bug that I don't understand
  triggerMainSliderSectionObservable(mainSliderSection:MainSliderSection,includeTimeout:boolean){
    
    setTimeout(()=>{
        this.changeMainSliderSectionObservable.next(mainSliderSection);
    },includeTimeout ? 100:0)
  }

  triggerMainSliderSectionSettled(mainSliderSection: MainSliderSection){
    this.mainSliderSectionSettledObservable.next(mainSliderSection);
  }

}
